/* global jQuery CustomEvent ajax_url */

(($) => {
  window.COMPONENTS || (window.COMPONENTS = {})

  // DEV MODE. ALWAYS USE COMPONENTS.utility.log() over console.log() to keep
  // our production consoles free of debug junk
  // This value should always be set to false when compiling for production
  COMPONENTS.dev_mode = true

  const evInit = new CustomEvent('components_init', { detail: 'components init start' })
  const evComplete = new CustomEvent('components_complete', { detail: 'components complete' })

  COMPONENTS.init = () => {
    $('body').removeClass('no-js') // signal the app the browser supports JS
    document.dispatchEvent(evInit)
    // Do any other main components work here
    COMPONENTS.ajaxURL = ajax_url
    COMPONENTS.utility.log('HELLO FROM COMPONENTS')
    COMPONENTS.isTouchDevice = function () {
      return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
    }

    document.dispatchEvent(evComplete)
  }

  COMPONENTS.componentsOnPage = function () {
    const utility = new COMPONENTS.Utility()
    const componentsAvailable = []
    $('[data-ecs-component]').each(function () {
      const $component = $(this)
      componentsAvailable.push($component.data('ecs-component'))
    })

    utility.log('COMPONENTS ON PAGE:', componentsAvailable)
  }

  $(document).ready(() => {
    COMPONENTS.init()
  })

  $(window).on('load', function () {
    // Set FancyBox defaults
    $.fancybox.defaults.buttons = [
      // "zoom",
      // "share",
      'slideShow',
      // "fullScreen",
      // "download",
      // "thumbs",
      'close'
    ]
    $.fancybox.defaults.mobile.hideScrollbar = false
    $.fancybox.defaults.mobile.clickSlide = 'close'
    $.fancybox.defaults.mobile.clickOutside = 'close'

    $('[data-ecs-components-control="nice-select"]').niceSelect()
  })
}
)(jQuery)
